export default __webpack_public_path__ + "c2ba769d6f2c3a8b76fc4b1d2fb08367.woff2";